import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styles from './TextEditor.scss';

const TextEditor = ({ label, onChange, extended, value, ...rest }) => {
  const toolbar = extended
    ? [
        ['bold', 'italic'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link']
    ] : [['bold', 'italic'], ['link']];
  const formats = extended
    ? ['bold', 'italic', 'link', 'list']
    : ['bold', 'italic', 'link'];
  return (
    <div style={{ marginBottom: '1em' }}>
      <p className={styles.label}>
        {label}
      </p>
      <ReactQuill
        theme={'snow'}
        modules={{
          clipboard: { matchVisual: false },
          toolbar
        }}
        formats={formats}
        value={value}
        onChange={onChange}
        {...rest}
      />
    </div>
  );
};

TextEditor.propTypes = {
  extended: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string
};

export default TextEditor;



// WEBPACK FOOTER //
// ./webpack/components/Modules/TextEditor/TextEditor.js